import React, { PureComponent } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Label, FormGroup } from 'reactstrap';
import { string, node, func } from 'prop-types';
import WithPlaceholder from '../../hoc/WithPlaceholder';
import { ThemedFMessage } from '../../hoc/IntlComponents';

class FlowTitle extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    onChangeTitle: func.isRequired,
    error: node,
  };

  static defaultProps = {
    error: '',
    title: '',
  };

  render() {
    const { title, onChangeTitle, error } = this.props;

    return (
      <FormGroup className={cn('form-group-upper-label', { 'has-error': error })}>
        <Label for="flow-title">
          <ThemedFMessage id="flow.form.title" />
        </Label>
        <WithPlaceholder
          id="flow-title"
          name="title"
          onChange={onChangeTitle}
          value={title}
          placeholder="flow.form.title"
          autoComplete="off"
          maxLength={70}
        />
        {error && <small className="form-text">{error}</small>}
      </FormGroup>
    );
  }
}

export default FlowTitle;
